import { EbooksContent, MediaContent, VideoContent } from './matchmaking-content.model';
import { CardProductCommerce } from 'commerce/models';
import { Step } from './matchmaking-steps';
import { OptionItem } from './option.model';
import { CustomPageTypes } from './custom-pages';

export enum BudgetRange {
    SMALL = '0-50k',
    MEDIUM = '50k-200k',
    LARGE = '200k-500k',
    ENTERPRISE = '500k+',
}

export enum Timeline {
    IMMEDIATE = '0-3 months',
    SHORT = '3-6 months',
    MEDIUM = '6-12 months',
    LONG = '12+ months',
}

export enum Application {
    Unknown = 0,
    TestingAndInspection = 1,
    LaboratoryAutomation = 2,
    InjectionMoldingAndMachineTending = 3,
    MaterialHandlingAndPackaging = 4,
    PrototypingAndInnovationHubs = 5,
    ResearchAndLaboratoryAutomation = 6,
    STEMEducationAndRoboticsTraining = 7,
    Screwdriving = 8,
    QualityInspection = 9,
    Welding = 10,
    CaseErectingBoxForming = 11,
    PalletizingAndDepalletizing = 12,
    MachineTending = 13,
}

export enum Industry {
    Unknown = 0,
    EducationAndScience = 1,
    ElectronicAndTechnology = 2,
    PharmaceuticalAndCosmetics = 3,
    PlasticAndPolymers = 4,
    MetalAndMachining = 5,
    AutomotiveAndSubcontractors = 6,
    Other = 7,
    FoodAndBeverages = 8,
}
export interface MatchmakingFormConfig {
    currentStep: Step;
    industries: string[] | null;
    applications: string[] | null;
    step1Options: OptionItem[] | null;
    step2Options: OptionItem[] | null;
    step2_5Options: OptionItem[] | null;
    step3Options: OptionItem[] | null;
    projectGoal: string | null;
    budgetRange: BudgetRange | null;
    timeline: Timeline | null;
    selectedApplication: Industry;
    selectedIndustry: Application;
    customIndustryText: string | null;
    decisionMaker: boolean | null;
    isCompleted: boolean;
    caseStories: MediaContent[];
    blogs: MediaContent[];
    videos: VideoContent[];
    products: CardProductCommerce[];
    ebooks: EbooksContent[];
    country: string | null;
    region: string | null;
    firstName: string | null;
    lastName: string | null;
    worktitle: string | null;
    workEmail: string | null;
    phoneNo: string | null;
    company: string | null;
    jobTitle: string | null;
    state_region_semea: string;
    userRole: string;
    user_role_subcategory_end_user: string;
    stepApplicationSpecific: StepApplicationSpecific;
}

export interface StepApplicationSpecific {
    questions: Questions;
    customPage: CustomPageTypes | null;
    otherText: string;
}

export interface Questions {
    question1: string;
    question2: string;
    question3: string;
    question4: string;
    question5: string;
    question6: string;
}

export type QuestionAnswers =
    | 'question1'
    | 'question2'
    | 'question3'
    | 'question4'
    | 'question5'
    | 'question6';
